import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import TopbarNotification from './TopbarNotification';
import TopbarChat from './TopbarChat';
import TopbarAlert from './TopbarAlert';
import TopbarSearch from './TopbarSearch';
import TopbarLanguage from './TopbarLanguage';
import { hasAccess } from "../../Services/SecurityService";
import { UserProps } from '../../../shared/prop-types/ReducerProps';
import {environment} from '../../../containers/environment';
import { BasicNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class Topbar extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired
  };

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, title, message, face) => {
    console.log("danger");
    return notificationTC.notice({
      content: <BasicNotification
        color={color}
        title={title}
        message={message}
        face={face}
        />,
      duration: null,
      closable: true,
      style: { top: 0, left: 'calc(100vw - 100%)' },
      className: `right-up ltr-support`,
    });
  };

  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = this.props;

    // MCCOSTA: Topbar

    let topbarAlert = '';
    let topbarNotification = '';
    let topbarChat = '';
    let link = <Link className="topbar__logo" to="/home" />
    if(environment.isAdmin()){
      link = <Link className="topbar__logo" to="/home" />
      topbarAlert = <TopbarAlert show={this.show} />
      topbarNotification = <TopbarNotification show={this.show} />
    }
    
    if(hasAccess("MENU_CHAT_VIEW")){
      topbarChat = <TopbarChat show={this.show} />
    }

    return (
      <div className="topbar">
        <style>{`
          .rc-notification-notice-close {
            color: #ffffff;
            opacity: 1;
          }
          `}</style>
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            {link}
          </div>
          <div className="topbar__right">
            <TopbarSearch />
            {topbarNotification}
            {topbarAlert}
            {topbarChat}
            {/* <TopbarMail new /> */}
            <TopbarProfile  />
            <TopbarLanguage />
          </div>
        </div>
      </div>
    );
  }
}

export default Topbar;
